import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-test-env-banner',
    templateUrl: './test-env-banner.component.html',
    styleUrls: ['./test-env-banner.component.scss']
})
export class TestEnvBannerComponent implements OnInit {
    constructor() {}

    ngOnInit() {}
}
